//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { ILabel } from '@models/ILabel';

export type LabelsSearchResolver = (
  labels: ILabel[],
  searchQuery: string,
) => Promise<ILabel[]> | ILabel[];

/**
 * Given a list of labels, returns labels whose "label" property starts with the searchString
 *
 * @param labels A list of labels to search
 * @param searchString A substring we should search for at the start of each label's name
 */
export const prefixSearch = (
  labels: ILabel[],
  searchString: string,
): ILabel[] => {
  return searchString.length > 0
    ? labels.filter(({ label: name }) => name.startsWith(searchString))
    : labels;
};
